<template>
  <section class="space-y-5">
    <header>
      <h2 class="text-lg font-semibold text-gray-900">Founder CTA</h2>
      <p class="text-sm text-gray-500">Floating button that opens a founder-message video lightbox.</p>
    </header>

    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700">Button label</label>
      <input
        v-model="content.label"
        type="text"
        maxlength="120"
        class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
        placeholder="A Word From Our Founder"
      >
    </div>

    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700">YouTube video URL</label>
      <input
        v-model="content.video_url"
        type="text"
        maxlength="500"
        class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
        placeholder="https://www.youtube.com/watch?v=..."
      >
      <p class="mt-1 text-xs text-gray-500">
        Accepts watch, youtu.be, /embed/, or /shorts/ URLs. Plays inside a lightbox when the button is clicked.
      </p>
    </div>

    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700">Modal title</label>
      <input
        v-model="content.modal_title"
        type="text"
        maxlength="250"
        class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
        placeholder="Why This Fight Matters"
      >
    </div>

    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700">Modal description</label>
      <textarea
        v-model="content.modal_description"
        rows="3"
        maxlength="1000"
        class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
        placeholder="A short line of copy shown below the video."
      />
    </div>

    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700">Fallback link (optional)</label>
      <input
        v-model="content.link"
        type="text"
        maxlength="500"
        class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
        placeholder="https://example.org/founder-message"
      >
      <p class="mt-1 text-xs text-gray-500">
        Shown inside the modal if the YouTube URL above is missing or unrecognized.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FounderCtaSectionEditor',
  props: {
    content: { type: Object, required: true },
  },
};
</script>
